import React, { useEffect, useMemo, useRef, useState } from 'react'
import SearchOptionsGroup, {
  SearchOptionsGroupItem,
} from 'components/Bimlink/ArticuloBimLink/SearchOptionsGroup'
import { compararPorPropiedad } from 'components/Celulas/NewCelula/ActivitiesCheckbox'
import TextInput from 'components/ui/Forms/TextInput'
import { useGetAllBimlinks } from 'lib/react-query/queries'
import ClearIcon from '@mui/icons-material/Clear'
import { useAddBimLinkToTipo } from 'context/AddBimLinkToTipoContext'

const BimLinkInput = () => {
  const { data } = useGetAllBimlinks()
  const { selectedBimlink, setSelectedBimlink } = useAddBimLinkToTipo()

  const rootEl = useRef(null)
  const [textInput, setTextInput] = useState('')
  const [showOptions, setShowOptions] = useState(false)

  const nameInputSelectedBimlink = useMemo(() => {
    return selectedBimlink ? `${selectedBimlink.code}` : ''
  }, [selectedBimlink])

  const handleSelectedBimlink = bimlink => {
    setSelectedBimlink(bimlink)
    setTextInput(`${bimlink.code}`)
    setShowOptions(false)
  }

  const filterData = () => {
    const bimlinks = data?.data?.data || []
    if (selectedBimlink && textInput === `${selectedBimlink.code}`) {
      return bimlinks
    }
    if (textInput.length >= 2) {
      return bimlinks.filter(item =>
        item.code.toLowerCase().includes(textInput.toLowerCase())
      )
    }
    return bimlinks
  }

  const handleMenuOpen = () => {
    setShowOptions(true)
  }

  useEffect(() => {
    // Reset seleccionado si borras el texto
    if (!textInput) {
      setSelectedBimlink(null)
    }
  }, [textInput, setSelectedBimlink])

  useEffect(() => {
    const handleClickOutside = event => {
      if (rootEl.current && !rootEl.current.contains(event.target)) {
        setShowOptions(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  if (!data) return <div>Loading...</div>

  return (
    <div style={{ position: 'relative' }} ref={rootEl}>
      <TextInput
        label="BimLinks"
        name="bimlinks"
        onChange={e => setTextInput(e.target.value)}
        placeholder="Buscar por código del bimlink. Escribe, al menos, dos caracteres"
        value={textInput || nameInputSelectedBimlink}
        inputclass="input-bimlink-to-tipo"
        onClick={handleMenuOpen}
        autoComplete="off"
        onReset={() => {
          setSelectedBimlink(null)
          setTextInput('')
        }}
      />

      {selectedBimlink && (
        <div
          className="icon-text-input-reset"
          onClick={() => {
            setSelectedBimlink(null)
            setTextInput('')
          }}
        >
          <ClearIcon />
        </div>
      )}

      {showOptions && (
        <SearchOptionsGroup width={rootEl.current}>
          {filterData().length === 0 ? (
            <div className="not-match-input-search">
              No hay ningún elemento que coincida con la búsqueda
            </div>
          ) : (
            filterData()
              .sort(compararPorPropiedad('code'))
              .map(bimlink => (
                <SearchOptionsGroupItem
                  key={bimlink._id}
                  title={bimlink.code}
                  item={bimlink}
                  handleSelectedItem={handleSelectedBimlink}
                  isSelected={selectedBimlink?._id === bimlink._id}
                />
              ))
          )}

        </SearchOptionsGroup>
      )}
    </div>
  )
}

export default BimLinkInput
